// extracted by mini-css-extract-plugin
export default {"master_filter":"TransfersFilters_master_filter__-ezAH"};